'use client';
import { useState } from 'react';
import type { LoginBranding } from '../lib/login-branding';

/**
 * En-tête de la page de connexion brandée (#37) : logo et nom du marchand. Repris tel quel par l'aperçu de
 * la fiche super admin (#38). Un logo qui ne se charge pas disparaît, le nom reste.
 */
export function LoginBrandHeader({ branding }: { branding: Pick<LoginBranding, 'name' | 'logoUrl'> }) {
  const [failedLogo, setFailedLogo] = useState<string | null>(null);
  const logo = branding.logoUrl && branding.logoUrl !== failedLogo ? branding.logoUrl : null;
  return (
    <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
      {logo && (
        // Le nom est écrit juste en dessous : le logo est décoratif pour un lecteur d'écran.
        // eslint-disable-next-line @next/next/no-img-element
        <img src={logo} alt="" onError={() => setFailedLogo(logo)}
          style={{ display: 'block', maxHeight: '64px', maxWidth: '200px', objectFit: 'contain', margin: '0 auto 0.75rem' }} />
      )}
      <div style={{ fontSize: '1.5rem', fontWeight: 800, color: 'var(--text)', marginBottom: '0.375rem', overflowWrap: 'anywhere' }}>
        {branding.name}
      </div>
      <p style={{ color: 'var(--muted)', fontSize: '0.9rem', margin: 0 }}>
        Bon retour&nbsp;! Connectez-vous pour continuer.
      </p>
    </div>
  );
}
